export const BASE_URL = "https://api.themoviedb.org";
export const POSTER_URL = "https://image.tmdb.org/t/p/w500/";
export const BACKEND_URL = "https://rexyapp.herokuapp.com/api";
export const TOKEN = localStorage.getItem("token");
export const AVATARS = [
    "../../images/avatars/cupcat.png",
    "../../images/avatars/kermit.jpg",
    "../../images/avatars/orcasplash.jpg",
    "../../images/avatars/cafe.jpg",
    "../../images/avatars/ghost.png",
    "../../images/avatars/peepo-comfy.jpeg",
    "../../images/avatars/instigatingcat.jpeg",
    "../../images/avatars/doghost.png",
    "../../images/avatars/zelda.png",
    "../../images/avatars/dogglasses.png"
]
export const UNAVAILABLE = "../../images/unavailable_poster.jpeg";